import * as React from 'react';
const SvgVerticalComponents = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={20}
    fill="none"
    viewBox="0 0 19 20"
    {...props}
  >
    <circle cx={9.5} cy={10} r={1.5} fill="currentColor" fillOpacity={0.65} />
  </svg>
);
export default SvgVerticalComponents;
